import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetStylerComponent } from './widget-styler.component';
import { createCustomElement } from '@angular/elements';
import { SanitizePipeModule } from '@digistore/ds24-ui/pipes';

@NgModule({
  declarations: [WidgetStylerComponent],
  imports: [CommonModule, SanitizePipeModule],
})
export class WidgetStylerModule {
  static initialize(injector: Injector) {
    const customComponent = createCustomElement(WidgetStylerComponent, {
      injector: injector,
    });
    customElements.define('ds-orderform-widget-styler', customComponent);
  }
}
